import { UserConstants } from '../constants';

let initialState = { Drivers: [], driversExist: false, driversLoading: false, driversError: '' };
export function driverPicker(state = initialState, action) {
    switch (action.type) {
    case UserConstants.DRIVERS_SUCCESS:
        return {
            Drivers: action.payload.data,
            driversExist: true,
            driversLoading: false,
            driversError: '',
        };
    case UserConstants.DRIVERS_REQUEST:
        return {
            driversExist: false,
            driversLoading: true,
            driversError: '',
        };
    case UserConstants.DRIVERS_ERROR:
        return {
            driversExist: false,
            driversLoading: false,
            driversError: action.payload.message,    
        };
    default:
        return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/DriversReducer.jsx